<template>
  <nav class="breadcrumb">
    <ul>
      <li>
        <router-link to="/" class="breadcrumb-item">
          <span class="breadcrumb-item active"><i class="fas fa-home "></i>&nbsp;</span>
        </router-link>
      </li>
      <li v-for="(item, index) in breadcrumbItems" :key="index">
        <span class="breadcrumb-item active">{{ index == 0 ? item : ' / ' + item }}</span>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useLanguageStore } from '../stores/language'

const route = useRoute()
const languageStore = useLanguageStore()
const { t } = languageStore

const getRouteNames = () => ({
  // Ana Menü Öğeleri
  'dashboard': t('sidebar.systemTitle', 'PassQR - Personel Takip Sistemi'),
  'branches': t('sidebar.branch', 'Şube'),
  'kiosk': t('sidebar.kiosk', 'QR Kiosk'),
  'kiosk-display': t('kiosk.title', 'QR Kiosk Ekranı'),
  'employees': t('sidebar.personnel', 'Personel'),
  'shifts': t('sidebar.shiftList', 'Vardiya Listesi'),
  'shift-rotations': t('sidebar.shiftRotations', 'Vardiya Rotasyonları'),
  'shift-employee-management': t('sidebar.shiftPersonnelManagement', 'Vardiya Personel Yönetimi'),
  'advance-requests-list': t('sidebar.advanceRequests', 'Avans Talepleri'),
  'subscription': t('sidebar.subscription', 'Abonelik'),
  'kvkk-consents': t('sidebar.kvkkConsents', 'KVKK Onayları'),
  'activity-list': t('sidebar.attendanceRecords', 'Giriş Çıkışlar'),
  'leave-balance-management': t('leaves.balanceManagement', 'İzin Bakiye Yönetimi'),
  'leave-balance': t('sidebar.leaveBalanceReport', 'İzin Bakiye Raporu'),
  'leave-balance-import': t('leaves.balanceImport', 'İzin Bakiye Aktarımı'),
  'suspicious-activities': t('sidebar.suspiciousActivities', 'Şüpheli İşlemler'),
  
  // Zimmet Yönetimi
  'assets': t('sidebar.assets', 'Zimmetler'),
  'upcoming-maintenance': t('sidebar.upcomingMaintenance', 'Yaklaşan Bakımlar'),
  'faults': t('sidebar.faultRecords', 'Arıza Kayıtları'),
  
  // İzin Planlama
  'leave-planning': t('sidebar.leavePlanning', 'İzin Planlama'),
  'leave-planning-calendar': t('breadcrumb.leavePlanningCalendar', 'İzin Planlama Takvimi'),
  
  // Personel Alt Menüleri
  'employee-import': t('sidebar.importPersonnel', 'Personel İçe Aktarma'),
  'employee-hire-resign': t('sidebar.personnelMovements', 'Personel Hareketleri'),
  'birthdays': t('sidebar.birthdays', 'Doğum Günleri'),

  // İzin Yönetimi Alt Menüleri
  'day-off-change': t('sidebar.dayOffChange', 'İzin Günü Değişikliği'),
  'leave-requests-list': t('sidebar.leaveRequests', 'İzin Talepleri'),
  'leave-types': t('sidebar.leaveTypes', 'İzin Türleri'),
  'leave-entitlements': t('sidebar.leaveEntitlements', 'İzin Hakedişleri'),
  'leave-usage-movements': t('sidebar.leaveUsageMovements', 'İzin Kullanım Hareketleri'),
  // Rapor Alt Menüleri
  'daily-attendance': t('sidebar.dailyAttendanceReport', 'Günlük Devam Raporu'),
  'monthly-summary': t('sidebar.monthlyTimesheet', 'Aylık Puantaj'),
  'absence-report': t('sidebar.absenceReport', 'Devamsızlık Raporu'),
  'employee-summary': t('breadcrumb.personnelSummary', 'Personel Özet Raporu'),
  'dinner-card-report': t('sidebar.mealCardReport', 'Yemek Kartı Raporu'),
  'holiday-work-compensation-report': t('sidebar.holidayWorkCompensationReport', 'Tatil Çalışması Hakediş Raporu'),
  'overtime-report': t('sidebar.overtimeReport', 'Fazla Mesai Raporu'),
  'employee-status-report': t('sidebar.personnelStatusReport', 'Personel Durum Raporu'),
  
  // Ayarlar Alt Menüleri
  'settings': t('sidebar.generalSettings', 'Ayarlar'),
  // Departmanlar Alt Menüleri
  'departments': t('sidebar.department', 'Departmanlar'),
  'department-employees': t('breadcrumb.departmentEmployees', 'Departman Personelleri'),
  // Roller ve İzinler Alt Menüleri
  'roles-permissions': t('sidebar.rolesAndPermissions', 'Roller ve İzinler'),
  // Bildirimler Alt Menüleri
  'notifications': t('sidebar.notifications', 'Bildirimler'),
  'users': t('sidebar.webPanelUsers', 'Web Panel Kullanıcıları'),
  'holidays': t('sidebar.holidays', 'Tatiller'),
  'duty-periods': t('sidebar.dutyPeriods', 'Görevli Zamanlar'),
  'branch-assignments': t('sidebar.branchAssignments', 'Şube Görevlendirmeleri'),
  'devices': t('sidebar.registeredDevices', 'Kayıtlı Cihazlar'),

  // Vardiya Takvimi
  'shift-calendar': t('sidebar.shiftCalendar', 'Vardiya Takvimi'),
  'daily-shift-planning': t('sidebar.dailyShiftPlanning', 'Günlük Vardiya Planlama'),
  'monthly-time': t('sidebar.monthlyTimesheetHours', 'Aylık Puantaj (Saat)'),
  'employee-monthly-attendance': t('sidebar.monthlyAttendanceReport', 'Aylık Giriş-Çıkış Raporu'),
  'weekly-employee-attendance': t('sidebar.weeklyWorkingHoursReport', 'Haftalık Çalışma Saati Raporu'),

  // Molalar Alt Menüleri
  'break-types': t('sidebar.breakTypes', 'Mola Tipleri'),
  'breaks': t('breadcrumb.breaks', 'Molalar'),
  'breaks-report': t('sidebar.breakMovements', 'Mola Hareketleri'),
  'break-summary-report': t('sidebar.breakSummaryReport', 'Mola Özet Raporu'),
  
  // Profil
  'profile-edit': t('header.editProfile', 'Profil Düzenle'),
  'change-password': t('header.changePassword', 'Şifre Değiştir'),
  
  // Servis Yönetimi
  'service-routes': t('sidebar.routes', 'Güzergahlar'),
  'service-vehicles': t('sidebar.serviceVehicles', 'Servis Araçları'),
  'service-assignments': t('sidebar.scheduleAndAssignments', 'Program ve Atamalar'),
  // Etkinlikler
  'events': t('sidebar.events', 'Etkinlikler'),
  // Prosedürler
  'procedures': t('sidebar.procedures', 'Prosedürler'),
})

const breadcrumbItems = computed(() => {
  const routeNames = getRouteNames()
  
  // Dashboard için özel kontrol
  if (route.path === '/' || route.name === 'dashboard') {
    return [routeNames['dashboard']]
  }
  
  // Nested örneği: employees-bulk-import
  if (route.name === 'employee-import') {
    return [routeNames['employees'], routeNames['employee-import']]
  }
  
  // Doğum günleri için nested breadcrumb
  if (route.name === 'birthdays') {
    return [routeNames['employees'], routeNames['birthdays']]
  }
  
  // İzin planlama takvimi için nested breadcrumb
  if (route.name === 'leave-planning-calendar') {
    return [routeNames['leave-planning'], routeNames['leave-planning-calendar']]
  }
  
  // Diğerleri için tek seviye
  if (routeNames[route.name as string]) {
    return [routeNames[route.name as string]]
  }
  
  return []
})
</script>

<style scoped>
.breadcrumb {
  padding: 0;
  margin-left: 16px;
  background: transparent;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
}

.breadcrumb ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.breadcrumb-item {
  color: #94a3b8;
  text-decoration: none;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.breadcrumb-item:hover {
  color: #38bdf8;
}

.breadcrumb-item.active {
  color: #e2e8f0;
  font-weight: 500;
}

.breadcrumb-separator {
  color: #64748b;
}

@media (max-width: 768px) {
  .breadcrumb {
    padding: 12px 16px;
  }
}
</style> 